import { computed, unref, watch } from "vue";
import { u as useSyncProp } from "./useSyncProp.js";
import { V as VaDropdown } from "../components/va-dropdown/index.js";
import { e as extractComponentProps } from "../utils/component-options/extract-component-options.js";
import { f as filterComponentProps } from "../utils/component-options/filter-props.js";
const VaDropdownProps = extractComponentProps(
  VaDropdown,
  ["innerAnchorSelector", "stateful", "keyboardNavigation", "modelValue"]
);
const useDropdownableProps = {
  ...VaDropdownProps,
  modelValue: {},
  /**
   * Close dropdown on value updated.
   * @default null - behavior controlled by component
   */
  closeOnChange: { type: Boolean, default: null },
  isOpen: { type: Boolean, default: void 0 }
};
const useDropdownableEmits = ["update:isOpen"];
const useDropdownable = function(props, emit, options = {}) {
  const [isOpenSync] = useSyncProp("isOpen", props, emit, false);
  const doWatch = computed(() => props.closeOnChange !== null ? props.closeOnChange : unref(options.defaultCloseOnValueUpdate || false));
  watch(() => props.modelValue, () => {
    if (doWatch.value) {
      isOpenSync.value = false;
    }
  });
  return {
    dropdownProps: filterComponentProps(VaDropdownProps),
    isOpenSync
  };
};
export {
  useDropdownableEmits as a,
  useDropdownable as b,
  useDropdownableProps as u
};
//# sourceMappingURL=useDropdownable.js.map
